<template>

  <AndamentoAgenti />
 
</template>

<script>
import AndamentoAgenti from '../components/pratiche/AndamentoAgenti.vue'

export default {
  components: {
    AndamentoAgenti
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

